import Modal from "tds/modal";

export { Modal };

customElements.define("tds-modal", Modal.CustomElementConstructor);
